import styled from 'styled-components';

const FieldActionMenu = styled.div`
  padding: ${(props): string => props.theme.spaces.md};
  display: grid;
  grid-template-columns: auto;
  grid-gap: ${(props): string => props.theme.spaces.md};
`;

export { FieldActionMenu };
